import { createAction, props } from '@ngrx/store';

// Load all tags
export const loadTags = createAction('[Tag] Load Tags');
export const loadTagsSuccess = createAction('[Tag] Load Tags Success', props<{ tags: any[] }>());
export const loadTagsFailure = createAction('[Tag] Load Tags Failure', props<{ error: string }>());

// Add tag
export const addTag = createAction('[Tag] Add Tag', props<{ name: string }>());
export const addTagSuccess = createAction('[Tag] Add Tag Success', props<{ tag: string }>());
export const addTagFailure = createAction('[Tag] Add Tag Failure', props<{ error: string }>());

// Remove tag
export const removeTag = createAction('[Tag] Remove Tag', props<{ name: string }>());
export const removeTagSuccess = createAction('[Tag] Remove Tag Success', props<{ tag: any }>());
export const removeTagFailure = createAction('[Tag] Remove Tag Failure', props<{ error: string }>());

// Attach tag to report
export const attachTag = createAction('[Tag] Attach Tag', props<{ searchId: number, tags: any }>());
export const attachTagSuccess = createAction('[Tag] Attach Tag Success', props<{ tags: any }>());
export const attachTagFailure = createAction('[Tag] Attach Tag Failure', props<{ error: string }>());

// Detach tag from report
export const detachTag = createAction('[Tag] Detach Tag', props<{ tag: string, tagValues: string[], searchId: string }>());
export const detachTagSuccess = createAction('[Tag] Detach Tag Success', props<{ tag: string }>());
export const detachTagFailure = createAction('[Tag] Detach Tag Failure', props<{ error: string }>());

// Load investment data - simplified to only need searchId
export const loadInvestment = createAction(
  '[Tag] Load Investment',
  props<{ searchId: number }>()
);
export const loadInvestmentSuccess = createAction(
  '[Tag] Load Investment Success',
  props<{
    searchId: string;
    investmentLabel: string;
    investmentColor: string;
  }>()
);
export const loadInvestmentFailure = createAction(
  '[Tag] Load Investment Failure',
  props<{ error: string }>()
);

// Reset investment data
export const resetInvestment = createAction('[Tag] Reset Investment');

// Sync investment data to report
export const syncInvestmentToReport = createAction(
  '[Tag] Sync Investment To Report',
  props<{
    searchId: number;
    investmentLabel: string;
    investmentColor: string;
  }>()
);

// Update report with latest investment data after changes
export const updateReportInvestment = createAction(
  '[Tag] Update Report Investment'
);

// Removed loadInvestmentBySearchId action as it's been replaced by simplified loadInvestment
